import React from 'react';
import { api } from '../services/api';
import { useApi } from '../hooks/useApi';
import Topbar from '../components/Topbar';
import StatCard from '../components/StatCard';
import MobilityDesertsPanel from '../components/MobilityDesertsPanel';
import Panel from '../components/Panel';
import { IconDesert, IconUsers, IconScale } from '../components/icons';

export default function Deserts() {
  const { loading, data, live } = useApi(() => api.mobilityDeserts());
  const deserts = data?.deserts || [];
  const high = deserts.filter((d) => /élev|haut/i.test(d.niveau || '')).length;
  const pop = deserts.reduce((a, d) => a + (d.population_estimee || 0), 0);

  return (
    <>
      <Topbar title="Déserts de mobilité" subtitle="Zones à forte demande et faible desserte (clustering — Dataset 2)" live={live} />
      <div className="content">
        {loading ? <div className="loading-screen">Chargement…</div> : (
          <>
            <div className="kpi-row kpi-row--3">
              <StatCard label="Zones identifiées" value={String(deserts.length)} icon={IconDesert} delay={0} />
              <StatCard label="Niveau élevé" value={String(high)} unit="zones" icon={IconScale} trend={{ dir: high ? 'down' : 'flat', text: 'à prioriser' }} delay={70} />
              <StatCard label="Population concernée" value={new Intl.NumberFormat('fr-FR', { notation: 'compact' }).format(pop)} icon={IconUsers} delay={140} />
            </div>
            <div className="grid grid--2-1">
              <MobilityDesertsPanel data={data} delay={120} />
              <Panel icon={IconScale} title="Recommandations" sub="Pistes d'action" delay={180}>
                <ul style={{ paddingLeft: 18, fontSize: 13.5, color: 'var(--slate-700)', lineHeight: 1.8 }}>
                  <li>Prioriser la desserte des zones en niveau <b>élevé</b>.</li>
                  <li>Croiser avec le réseau de bus actuel (superposition).</li>
                  <li>Évaluer de nouvelles lignes via l'<b>Optimiseur</b>.</li>
                  <li>Suivre l'évolution mensuelle des scores.</li>
                </ul>
              </Panel>
            </div>
          </>
        )}
      </div>
    </>
  );
}
